<script setup lang="ts">
defineOptions({
  name: 'CoreNotificationQueue',
});

const { t } = useI18n({
  useScope: 'local',
});

const { refreshQueueStatusStore } = useQueueStore();
const { queueStatus } = storeToRefs(useQueueStore());

const timerGetQueuestatus = setInterval(refreshQueueStatusStore, 30000);

refreshQueueStatusStore();

onBeforeUnmount(() => {
  clearInterval(timerGetQueuestatus);
});

const snackbar = ref(false);

watch(queueStatus, (newVal) => {
  if (!newVal) {
    snackbar.value = true;
  } else {
    snackbar.value = false;
  }
}, { immediate: true });
</script>

<i18n lang="json">
{
  "en": {
    "close": "Close",
    "snackbarText": "The platform is in computing mode: compensation plan engine is currently running network calculations. Some functions might be unavailable in this mode."
  },
  "ru": {
    "close": "Закрыть",
    "snackbarText": "Платформа в режиме вычислений: движок плана компенсации выполняет текущие вычисления сетевых расчетов. Некоторые функции могут быть недоступны в данном режиме."
  },
  "fr": {
    "close": "Fermer",
    "snackbarText": "La plateforme est en mode de calcul: le moteur du plan de compensation exécute actuellement des calculs réseau. Certaines fonctions peuvent être indisponibles dans ce mode."
  },
  "es": {
    "close": "Cerrar",
    "snackbarText": "La plataforma está en modo de cálculo: el motor del plan de compensación está ejecutando actualmente cálculos de red. Algunas funciones pueden no estar disponibles en este modo."
  },
  "de": {
    "close": "Schließen",
    "snackbarText": "Die Plattform befindet sich im Berechnungsmodus: Die Vergütungsplan-Engine führt derzeit Netzwerkberechnungen durch. Einige Funktionen sind in diesem Modus möglicherweise nicht verfügbar."
  },
  "ja": {
    "close": "閉じる",
    "snackbarText": "プラットフォームは計算モードです。報酬プランエンジンが現在ネットワーク計算を実行中です。このモードでは一部の機能が利用できない場合があります。"
  }
}
</i18n>

<template>
  <v-snackbar
    v-model="snackbar"
    multiLine
  >
    {{ t('snackbarText') }}

    <template #actions>
      <VBtnSnackbar
        color="white"
        variant="text"
        @click="snackbar = false"
      >
        {{ t('close') }}
      </VBtnSnackbar>
    </template>
  </v-snackbar>
</template>
